export default __webpack_public_path__ + "static/media/2018 (6).b57ceec1.jpg";